webpackJsonp([145],{

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceDepartmentJobBatchForm_vue__ = __webpack_require__(2675);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15fcb200_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceDepartmentJobBatchForm_vue__ = __webpack_require__(4011);
function injectStyle (ssrContext) {
  __webpack_require__(3997)
  __webpack_require__(3999)
  this["$style"] = __webpack_require__(4001)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15fcb200"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceDepartmentJobBatchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15fcb200_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceDepartmentJobBatchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(40);
var getKeys = __webpack_require__(101);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(235).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1446), __esModule: true };

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1447);
module.exports = __webpack_require__(12).Object.values;


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(28);
var $values = __webpack_require__(1441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function () {
  return new Worker(__webpack_require__.p + "2f6ec96fc704f66aecaa.worker.js");
};

/***/ }),

/***/ 2675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DepartmentJobBatchExcel__ = __webpack_require__(4003);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DepartmentJobBatchExcel: __WEBPACK_IMPORTED_MODULE_4__components_DepartmentJobBatchExcel__["a" /* default */] },
  data: function data() {
    return {
      form: {
        data: []
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, request.map([]), {
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.$refs.userBankExcel.$refs.userBankBatchExcel.clearFiles();
    },
    getFormData: function getFormData() {
      return _.cloneDeep(this.form.data);
    },
    onSubmit: function onSubmit() {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件');
      } else {
        this.create();
      }
    },
    excelFileRemove: function excelFileRemove(fileList) {
      if (fileList.length === 0) {
        this.form.data = [];
      }
    },
    create: function create() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, index, param, num, info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _this.getFormData();

                _this.error_data = [];
                index = 0;

              case 3:
                if (!(index < data.length)) {
                  _context.next = 20;
                  break;
                }

                param = data[index];
                num = index + 1;

                _this.percentage = num / data.length * 100;

                info = '第' + num + '行 ';

                if (!_this.checkParams(param, info)) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return request.loading('batchCreateDepartmentJob', param);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](9);

                _this.error_data.push(info + _context.t0.message);

              case 17:
                index++;
                _context.next = 3;
                break;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 14]]);
      }))();
    },
    checkParams: function checkParams(param, info) {
      var err = '';
      var rule = {
        department_name: '部门名称',
        name: '岗位名称'
      };

      for (var ruleKey in rule) {
        if (!param[ruleKey]) {
          err = rule[ruleKey] + ' 为空';
          break;
        }
      }
      if (err) {
        this.error_data.push(info + err);
        return false;
      }
      return true;
    }
  })
});

/***/ }),

/***/ 2676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var worker = new __WEBPACK_IMPORTED_MODULE_3__worker_read_xlsx_worker___default.a();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    getDemo: function getDemo() {
      var demo = [{ 'department_name': '产品规划部', 'name': '产品经理' }, { 'department_name': '产品规划部', 'name': '产品主管' }, { 'department_name': '产品规划部', 'name': 'PM' }, { 'department_name': '产品规划部', 'name': '执行主管' }];
      this.$export('批量添加岗位 Demo', demo, {
        fileHeader: [{ key: 'department_name', text: '部门名称' }, { key: 'name', text: '岗位名称' }]
      });
    },
    excelFileChange: function excelFileChange(file, fileList) {
      if (file.status === 'ready') {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length >= 2) {
          fileList.shift();
        }
      }
    },
    excelFileRemove: function excelFileRemove(file, fileList) {
      this.$emit('excelFileRemove', fileList);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      var _this = this;

      this.loading = true;
      this.$emit('change-file', obj.file);
      worker.postMessage({ file: obj.file, options: { header: 1 } });
      worker.onmessage = function (event) {
        // 处理数据
        _this.handleExcelData(event.data);
        _this.loading = false;
      };
    },
    handleExcelData: function handleExcelData(rows) {
      var _this2 = this;

      var items = [];
      var tableHeader = {
        department_name: { index: null, text: '部门名称' },
        name: { index: null, text: '岗位名称' }
      };
      try {
        rows.forEach(function (row, rowIndex) {
          var item = {};
          row.forEach(function (cell, cellIndex) {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var header = _step.value;

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(header.index)) {
                      _this2.loading = false;
                      _this2.$refs.userBankBatchExcel.clearFiles();
                      throw new Error('\u627E\u4E0D\u5230 [' + header.text + '] \u8868\u5934');
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
              // 表格的行数据获取
              for (var field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell;
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(tableHeader)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _header = _step2.value;

                  if (cell === _header.text) {
                    _header.index = cellIndex;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          });
          rowIndex && items.push(item);
        });
        this.$emit('change', items);
      } catch (e) {
        this.$alert(e.toString(), '提示', { type: 'error' });
        throw new Error(e);
      }
    }
  }
});

/***/ }),

/***/ 3997:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3f15f8a4", content, true, {});

/***/ }),

/***/ 3998:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceDepartmentJobBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3999:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4f560ed0", content, true, {});

/***/ }),

/***/ 4000:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceDepartmentJobBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4001:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4002);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("45068e78", content, true, {});

/***/ }),

/***/ 4002:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FinanceDepartmentJobBatchForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepartmentJobBatchExcel_vue__ = __webpack_require__(2676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bedc0a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepartmentJobBatchExcel_vue__ = __webpack_require__(4010);
function injectStyle (ssrContext) {
  __webpack_require__(4004)
  __webpack_require__(4006)
  this["$style"] = __webpack_require__(4008)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bedc0a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepartmentJobBatchExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bedc0a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepartmentJobBatchExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4004:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4005);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0ff94faf", content, true, {});

/***/ }),

/***/ 4005:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DepartmentJobBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4006:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4d2442eb", content, true, {});

/***/ }),

/***/ 4007:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "a[data-v-3bedc0a8]{margin-right:10px;margin-bottom:10px}.re-el-upload-width-max[data-v-3bedc0a8] .el-upload-dragger{height:200px}", "", {"version":3,"sources":["/workspace/src/views/finance-config/components/DepartmentJobBatchExcel.vue"],"names":[],"mappings":"AACA,mBAAmB,kBAAkB,kBAAkB,CACtD,AACD,4DAA4D,YAAY,CACvE","file":"DepartmentJobBatchExcel.vue","sourcesContent":["\na[data-v-3bedc0a8]{margin-right:10px;margin-bottom:10px\n}\n.re-el-upload-width-max[data-v-3bedc0a8] .el-upload-dragger{height:200px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4008:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4009);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f21c17b6", content, true, {});

/***/ }),

/***/ 4009:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DepartmentJobBatchExcel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"DepartmentBatchExcel",staticClass:"re-el-upload-width-max",attrs:{"drag":"","action":"","accept":".xlsx","on-remove":_vm.excelFileRemove,"on-change":_vm.excelFileChange,"before-upload":_vm.beforeFileUpload,"http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")]),_vm._v(" "),_c('br'),_vm._v("\n    只能选择Excel文件\n  ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n    Excel需要包含表头[部门名称，岗位名称] "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("岗位名称不得重复")]),_vm._v(" "),_c('br'),_vm._v("\n    字段值不得为空 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.getDemo}},[_vm._v("下载 Demo\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务中心设置管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"选择Excel"}},[_c('department-job-batch-excel',{ref:"departmentJobExcel",on:{"excelFileRemove":_vm.excelFileRemove,"change-file":function (_) { return this$1.file = _; },"change":function (_) { return this$1.form.data = _; }}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传进度"}},[_c('div',{staticStyle:{"margin-top":"8px"}},[(_vm.percentage < 100)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":18,"color":"#666666"}}):_vm._e(),_vm._v(" "),(_vm.percentage === 100)?_c('el-progress',{attrs:{"percentage":100,"stroke-width":18,"status":"success"}}):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"错误记录"}},[_vm._l((_vm.error_data),function(item){return _c('div',[_c('span',[_vm._v(_vm._s(item))])])})],2)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("开始上传\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/department-management-batch-create-job.a3d14d20d9a720776cb0.js